<template>
  <svg :style="style" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3945">
    <path
      d="M914.286 802.89q0 68.534-41.692 108.25T761.71 950.858H262.29q-69.12 0-110.884-39.716T109.714 802.89q0-30.281 1.975-59.172t7.973-62.318 15.14-62.025 24.576-55.735 35.401-46.3 48.86-30.573 63.707-11.41q5.12 0 23.991 12.287t42.57 27.429 61.732 27.429 76.288 12.288 76.288-12.288 61.732-27.429 42.57-27.429 23.99-12.288q34.89 0 63.708 11.41t48.86 30.574 35.4 46.3 24.576 55.735 15.141 62.025 7.973 62.318 1.974 59.172zM731.429 292.57q0 90.844-64.293 155.136T512 512t-155.136-64.293-64.293-155.136 64.293-155.136T512 73.143t155.136 64.292 64.293 155.136z"
      p-id="3946">
    </path>
  </svg>
</template>

<script>
export default {
  name: 'user',
  props: {
    width: {
      type: String,
      default: '2em'
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  },
  data() {
    return {
      style: {
        width: this.width,
        fill: this.color,
        'vertical-align': 'middle',
        overflow: 'hidden',
      }
    }
  }
}
</script>